import { LitElement, html } from 'lit';

import { LIT_CSS_VARIABLES } from '@Root/lib/lit-styles.js';
import {
  SHARED_CLASSES,
  SHARED_ELEMENTS,
} from '@Root/lib/lit-3form-block/styles.js';

import { styles } from './css';

class GlobalSearch extends LitElement {
  static properties = {
    inputValue: {},
  };

  static get styles() {
    return [LIT_CSS_VARIABLES, SHARED_ELEMENTS, SHARED_CLASSES, styles];
  }

  constructor() {
    super();
    this.inputValue = '';
    this.addEventListener('keyup', e => this.keyupEventFired(e));
  }

  focus() {
    // Small delay lets the panel transition finish so mobile browsers
    // reliably raise the keyboard.
    const input = this.renderRoot?.querySelector('input');
    if (input) setTimeout(() => input.focus(), 50);
  }

  blur() {
    // Explicit blur so iOS Safari can zoom the viewport back out after the
    // input loses focus (closing the containing panel alone doesn't blur).
    this.renderRoot?.querySelector('input')?.blur();
  }

  closeSearch() {
    // Ensure any mobile keyboard zooming is removed by blurring input before
    // closing the panel.
    const input = this.renderRoot?.querySelector('input');
    if (input && typeof input.blur === 'function') input.blur();

    this.inputValue = '';
    this.dispatchEvent(
      new CustomEvent('close-search', { bubbles: true, composed: true })
    );
  }

  render() {
    return html`
      <section>
        <form method="get" action="/search" role="search">
          <label for="search-input" class="visually-hidden">Search 3form</label>
          <img
            src="/static/icons/SVG/search.svg"
            alt=""
            role="presentation"
            class="search-icon"
          />
          <input
            type="text"
            placeholder="Search 3form"
            id="search-input"
            name="${this.inputName}"
          />
          <button
            type="button"
            class="close-search"
            aria-label="Close search"
            @click=${this.closeSearch}
          >
            <img src="/static/icons/SVG/close.svg" alt="" role="presentation" />
          </button>
        </form>
      </section>
    `;
  }

  get inputName() {
    return 'q';
  }

  keyupEventFired(event) {
    if (event.key === 'Escape') this.closeSearch();
  }
}

customElements.define('global-search', GlobalSearch);
